import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { createWorkspaceQuiz } from '../../../api/workspaces/quiz';

export function useCreateWorkspaceQuiz() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createWorkspaceQuiz,
    onSettled: (_data, _error, { workspaceId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.allQuizzes(workspaceId)
      );
    },
  });
}
